import {takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {tablesAction} from 'utils/tables';

import {GetMilkabilityReportsAction, milkabilityAction} from '../action';

const tableId = 'milkabilityOverview';

function* execute(action: GetMilkabilityReportsAction): SagaIterator {
    const {tableDataRequest} = action.payload;
    yield* put(tablesAction.getTableData({
        tableDataRequest,
        apiRequest: Api.getMilkabilityReports,
        successAction: milkabilityAction.getMilkabilityReportsSuccess,
        tableId,
    }));
}

/** Watches milkability overview fetch requests and refreshes the connected table. */
export function* getMilkabilityReportsSaga(): SagaIterator {
    yield takeLatestF('milkability/GET_MILKABILITY_REPORTS', execute);
}
